import axios from 'axios'
import { getTenantSlug } from './tenant'

// Resuelve la baseURL de la API. Si VITE_API_URL apunta a localhost pero la app
// se abrió desde otro dispositivo (p. ej. el celular por la IP de la PC en la
// LAN), reescribe el host al mismo desde el que se sirve el front. Así no hay
// que editar el .env por cada IP para probar en el teléfono.
const resolveApiBase = () => {
    const configured = import.meta.env.VITE_API_URL || 'http://localhost:3000/api'
    try {
        const url = new URL(configured)
        const host = window.location.hostname
        const apiIsLocal = url.hostname === 'localhost' || url.hostname === '127.0.0.1'
        const pageIsLocal = host === 'localhost' || host === '127.0.0.1'
        if (apiIsLocal && !pageIsLocal) {
            url.hostname = host
            return url.toString().replace(/\/$/, '')
        }
    } catch { /* URL inválida — usa el valor configurado tal cual */ }
    return configured
}

const api = axios.create({
    baseURL: resolveApiBase(),
})


api.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    const slug = getTenantSlug()
    if (slug) config.headers['x-tenant'] = slug

    return config
})

export default api
